import { FC, Fragment } from 'react';
import { Outlet } from 'react-router-dom';

import { Tooltip } from 'react-tooltip';

import { BackToTop, DocumentTitle, GlobalLoader, LazyLoader, ReturnProvider } from '@hsp/react-component-library';

import { t } from 'utilities/strings';

import Scroll from './component/top-support-button';
import { useConfiguration } from './hooks';

import 'assets/scss/main.scss';

const App: FC = () => {
  const { isAuthenticated } = useConfiguration();

  return (
    <Fragment>
      <DocumentTitle title={t()} />
      <LazyLoader>
        <ReturnProvider isAuthenticated={isAuthenticated}>
          <Outlet />
        </ReturnProvider>
      </LazyLoader>
      <BackToTop>
        <Scroll />
      </BackToTop>
      <Tooltip
        id="global-tool-tip"
        variant="info"
      />
      <GlobalLoader />
    </Fragment>
  );
};

export default App;
